module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAfElEQVR42uWTwQqAIAyGfdZeoHN08IEFbzE95HLBYDGmo4798OEQ9w0UAyLexBjRwd4JBPc9BLVWBABFKUVKVlNAObag6KFGXs/O8kYgAVOQUlLIsMwU5JwZnib3poLZK/gERn4g+H6JepqufQKuR0LzM7XWRtAZW+BFCi4gNB3nGM87qwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/x-office-presentation.png
// module id = P1ow
// module chunks = 1